import { render } from "./Details.vue?vue&type=template&id=87055668&scoped=true"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"

import "./Details.vue?vue&type=style&index=0&id=87055668&scoped=true&lang=css"
import "./Details.vue?vue&type=style&index=1&id=87055668&lang=css"

import exportComponent from "/Users/iammaham/Documents/JS/estate_soluce/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87055668"]])

export default __exports__